import { Link } from 'react-router-dom'
import { BlogPost } from '@/lib/types/contentful'

interface BlogCardProps {
  post: BlogPost
}

export function BlogCard({ post }: BlogCardProps) {
  // Guard against undefined post or missing fields
  if (!post?.fields) {
    return null
  }

  const {
    title,
    seoPath,
    metaDescription,
    readTime,
    category
  } = post.fields

  // Guard against missing required fields
  if (!title || !seoPath) {
    return null
  }

  return (
    <article className="bg-card rounded-lg overflow-hidden border border-border/10 h-full flex flex-col transition-all duration-300 hover:shadow-lg hover:border-border/30">
      <div className="p-6 flex flex-col flex-grow">
        <div className="flex items-center justify-between mb-4">
          {category && (
            <span className="text-sm text-primary font-medium">{category}</span>
          )}
          {readTime && (
            <span className="text-sm text-muted-foreground">{readTime}</span>
          )}
        </div>

        <Link to={`/${seoPath}`} className="group">
          <h3 className="text-xl font-semibold mb-2 group-hover:text-primary transition-colors">
            {title}
          </h3>
        </Link>

        {metaDescription && (
          <p className="text-muted-foreground mb-4 line-clamp-2">{metaDescription}</p>
        )}

        <div className="mt-auto pt-4 border-t border-border/10">
          <div className="flex justify-end items-center">
            <Link
              to={`/${seoPath}`}
              className="text-sm font-medium text-primary hover:text-primary/90 transition-colors py-3 px-2 inline-block min-w-[100px] text-right"
            >
              Read more →
            </Link>
          </div>
        </div>
      </div>
    </article>
  )
}